import { api } from "./Api";

export const SubcriptionApis = {
    trailCall: (data) => api.post("/usermgmt/createLicenseManagementForTrial/crm_square_Cxsquare@481!", data),
    addAiTokens: (data,companyCode) => api.post(`/usermgmt/addAiTokens/crm_square_Cxsquare@481!/${companyCode}`, data),
    createOneTimeCheckout: (data, headers) => api.post(`/usermgmt/createOneTimeCheckout/${headers}`, data),
    userProfile: (headers) => api.get(`/usermgmt/userProfileByToken/${headers}`),
    updateGenerateInvoice: (data, id) => api.put(`/usermgmt/updateGenerateInvoice/${id}`, data),
    getSessionStatus: (id) => api.get(`/usermgmt/getSessionStatus/${id}`),
    payAmountForInvoice: (data) => api.post("/usermgmt/payAmountForInvoice", data),
    updateInvoiceAfterPayment: (invoiceId, companyId, amount, data) => api.put(`/usermgmt/updateInvoiceAfterPayment/${invoiceId}/${companyId}/${amount}`, data),
    decodeTokenByValue: (id) => api.get(`/usermgmt/decodeTokenByValue/${id}`),
};